var map = {
	"./certCenter.router.js": "ab66",
	"./class.router.js": "a827",
	"./college.router.js": "65b5",
	"./course.router.js": "05b2",
	"./examination.router.js": "dc49",
	"./finance.router.js": "53ba",
	"./index.router.js": "407a",
	"./live.router.js": "ee36",
	"./student.router.js": "0d8b",
	"./teacher.router.js": "f79f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9a40";